export function escapeRegExp(stringToGoIntoTheRegex) {
    return stringToGoIntoTheRegex.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
